// extracted by mini-css-extract-plugin
module.exports = {"locl-ops-base-layout":"base-layout_locl-ops-base-layout__3c4Dy","locl-ops-base-layout__main":"base-layout_locl-ops-base-layout__main__Ofo__"};